// static/table_engine_src/util/dom.js

export const ensureSection = (table, tag) => {
  let el = table.querySelector(tag);
  if (!el) {
    el = document.createElement(tag);
    table.appendChild(el);
  }
  return el;
};

export const escCss = (s) => {
  try {
    return CSS.escape(String(s));
  } catch {
    return String(s).replace(/["\\]/g, "\\$&");
  }
};

export function isMac() {
  return /Mac|iPhone|iPad|iPod/.test(navigator.platform || "");
}